import { AxiosProvider } from "./config";

const urlBase = process.env.REACT_APP_API_URL || "https://node.clubecerto.com.br/superapp/";
class API {
  authLogin = async (payload) => {
    console.log(payload);
    let URL;
    if (payload.id) {
      URL = `${urlBase}user/login/direct/${payload.id}`;
    } else {
      URL = `${urlBase}user/login/cashback`;
    }
    const { data } = await AxiosProvider.post(URL, payload);
    return data;
  };

  userRegister = async (payload) => {
    const { data } = await AxiosProvider.post(`${urlBase}user`, payload);
    return data;
  };

  updateUser = async ({ token, payload }) => {
    const { data } = await AxiosProvider.patch(`${urlBase}user`, payload, { headers: { Authorization: token } });
    return data;
  };

  sendEmailAndVerifyCode = async ({ token, payload }) => {
    const { data } = await AxiosProvider.patch(`${urlBase}user/email`, payload, { headers: { Authorization: token } });
    return data;
  };

  getCompaniesList = async ({ token, name, page }) => {
    const { data } = await AxiosProvider.get(`${urlBase}cashbackWeb/establishment/?limit=10&${page ? "page=" + page + "&" : "page=0&"}${name ? "name=" + name : ""}`, {
      headers: { Authorization: token },
    });
    return data;
  };

  companiesDetail = async ({ id, token }) => {
    const { data } = await AxiosProvider.get(`${urlBase}cashbackWeb/establishment/${id}`, { headers: { Authorization: token } });
    return data;
  };

  getCompanyLogo = async ({ id }) => {
    const { data } = await AxiosProvider.get(`https://clubecerto.com.br/ws/api/2/extensao/brand/${id}.png`);
    return data;
  };
  getCashbackHistory = async ({ token }) => {
    const { data } = await AxiosProvider.get(`${urlBase}cashbackWeb/withdrawalReport?limit=20&page=0`, { headers: { Authorization: token } });
    return data;
  };
  cpfVerify = async ({ cpf }) => {
    const { data } = await AxiosProvider.post(`${urlBase}user/verify`, {
      cpf,
    });
    return data;
  };

  getExtractsAndResume = async ({ token }) => {
    const { data } = await AxiosProvider.get(`${urlBase}cashbackWeb/summaryAndExtract?limit=20&page=0`, { headers: { Authorization: token } });
    return data;
  };
  forgotPassword = async (payload) => {
    const { data } = await AxiosProvider.post(`${urlBase}user/recovery`, payload);
    return data;
  };
  viewPromotions = async ({ id }) => {
    const { data } = await AxiosProvider.get(`https://clubecerto.com.br/ws/api/2/extensao/all_promotions.php${id ? "?id=" + id : ""}`);
    return data;
  };
  rescueAllValue = async ({ token }) => {
    const { data } = await AxiosProvider.post(`${urlBase}cashbackWeb/withdrawal`, {}, { headers: { Authorization: token } });
    return data;
  };
  getUserData = async ({ token }) => {
    const { data } = await AxiosProvider.get(`${urlBase}user`, { headers: { Authorization: token } });
    return data;
  };
  getAssetsCompany = async () => {
    let code = localStorage.getItem("charCode");
    if (!code) {
      code = process.env.REACT_APP_SUPERAPP_TOKEN;
    }
    const { data } = await AxiosProvider.get(`${urlBase}locations/company/${code}`);
    return data;
  };
}

const api = new API();

export default api;
